export const API_REQUEST = 'API_REQUEST';

// api interaction
export const VERIFY_SUBMIT = 'VERIFY_SUBMIT';
export const VERIFY_SET_HISTORY = 'VERIFY_SET_HISTORY';

export const XHR_VERIFY_HISTORY = 'XHR_VERIFY_HISTORY';

// xhr
export const XHR_IN_PROGRESS = 'XHR_IN_PROGRESS';
export const XHR_COMPLETE = 'XHR_COMPLETE';

// auth
export const SIGN_IN = 'SIGN_IN';
export const SIGN_OUT = 'SIGN_OUT';
export const UPDATE_PROFILE = 'UPDATE_PROFILE';

export const XHR_USERCHECK = 'USER_CHECK';
export const XHR_CONFIRM_PASS = 'CONFIRM_PASSWORD';

export const GET_ORGANIZATION = 'GET_ORGANIZATION';
export const GET_ORGANIZATION_MEMBERS = 'GET_ORGANIZATION_MEMBERS';

export const ROLE_OWNER = 'Owner';
export const ROLE_ADMIN = 'Admin';
export const ROLE_VIEW_ONLY = 'View-only';

export const PAYMENT_STATUS = Object.freeze({
  FAILED: 'failed',
  FREE_TRIAL: 'FREE',
  PENDING: 'pending',
  SUCCEEDED: 'succeeded',
  UNKNOWN: 'unknown',
});

export const FILE_STATUS_LIST = {
  keep: 'Keep',
  replace: 'Replace',
  discard: 'Discard',
};